<template>

    <div>

        <!-- maze -->
        <si_maze class="lc_maze" :p_width_n="co_mazeWidth_n" :p_height_n="co_mazeHeight_n" :p_wall-size_n="wallSize_n"
                 v-if="!co_currentPageWhiteLabelPayment_b"
                 :p_line-width_n="0.2" p_color_s="purple"  ></si_maze>

        <!-- body -->
        <div class="TQ_minHeight_bodyFullScreen">
            <keep-alive >
                <router-view />
            </keep-alive>
        </div>

    </div>

</template>

<script>
    import {ass_navTabs} from "@/assets/scripts/Ass_NavTabs";
    import {store_getStateValue_vo, store_setStateValue} from "@/store";
    import {store_var} from "@/store";
    import TqLoaderContainer from "../components/basic/TqLoaderContainer";
    import {
        ass_img_facebook_w,
        ass_img_info_b,
        ass_img_instagram_w,
        ass_img_twitter_w, ass_img_youtube_w
    } from "@/assets/scripts/Ass_Files";
    import {route_currentPath2_s, route_currentPath_s, route_moveToRoute} from "@/router";
    import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";
    import {enum_moveToOptions, enum_questCategories} from "../../functions/src/shareCode/Share_S_Enum";
    import Si_maze from "@/components/a_smartIcons/si_maze";
    import TqLink from "@/components/basic/TqLink";
    import TqImage from "@/components/basic/TqImage";
    import {serverAuth_currentUserData_get_vl_fp} from "@/scripts/Server/S_ServerAuth";

    export default {
        name: "v_Player",
        components: {TqImage, TqLink, Si_maze, TqLoaderContainer},
        data(){
            return {
                wallSize_n                  : 15,

                server_storeChats_byId_c : {},
                server_currentUserData_c : undefined,

                store_system_langCode_ve    : store_getStateValue_vo(store_var.system_langCode),

                enum_moveToOptions          : enum_moveToOptions,
                enum_questCategories        : enum_questCategories,
                ass_strings                 : ass_strings,
                ass_img_facebook_w          : ass_img_facebook_w,
                ass_img_twitter_w          : ass_img_twitter_w,
                ass_img_instagram_w         : ass_img_instagram_w,
                ass_img_youtube_w         : ass_img_youtube_w,
            }
        },
        computed:{
            co_mazeHeight_n(){
                return window.innerHeight / this.wallSize_n
            },
            co_mazeWidth_n(){
                return window.innerWidth / this.wallSize_n
            },
            co_currentPageWhiteLabelPayment_b(){
                let path_s = route_currentPath_s(this.$route)
                return path_s.includes(enum_moveToOptions.player_store_whiteLabel)
            },
            co_showBottomSiteMap_b(){
                let path_s = route_currentPath_s(this.$route)

                return !path_s.includes(enum_moveToOptions.player_store_whiteLabel) && !path_s.includes(enum_moveToOptions.player_play_entry_ticket)
            }

        },
        created(){

            store_setStateValue(store_var.navBar_tabs_ac,
                [ass_navTabs.player_quests, ass_navTabs.player_explore, ass_navTabs.player_profile])

            store_setStateValue(store_var.navBar_menu_ac, [
                {img_r : ass_img_info_b, text_blc_s : ass_strings.oneWord_about,  onClickDo_f : () => { route_moveToRoute(enum_moveToOptions.standAlong_about)}}
            ])

            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_currentUserData_c = userData_c
            })

        },
    }
</script>

<style scoped class="scss">

.lc_maze{
    position: fixed;
    top: 0;
    right: 0;
    z-index: -1;
}
</style>